import { CurrencyOptionGq } from './CurrencyOptionGq';

export const currencyList: CurrencyOptionGq[] = [
  {
    id: 1,
    name: 'Swedish Krona',
    code: 'SEK',
    symbol: 'kr',
    symbolPlacement: 'after',
  },
  {
    id: 2,
    name: 'Norwegian Krone',
    code: 'NOK',
    symbol: 'kr',
    symbolPlacement: 'after',
  },
  {
    id: 3,
    name: 'Danish Krone',
    code: 'DKK',
    symbol: 'kr',
    symbolPlacement: 'after',
  },
  {
    id: 4,
    name: 'British Pound Sterling',
    code: 'GBP',
    symbol: '£',
    symbolPlacement: 'before',
  },
  {
    id: 5,
    name: 'Euro',
    code: 'EUR',
    symbol: '€',
    symbolPlacement: 'before',
  },
  {
    id: 6,
    name: 'United States Dollar',
    code: 'USD',
    symbol: '$',
    symbolPlacement: 'before',
  },
  {
    id: 7,
    name: 'Canadian Dollar',
    code: 'CAD',
    symbol: '$',
    symbolPlacement: 'before',
  },
  {
    id: 8,
    name: 'Swiss Franc',
    code: 'CHF',
    symbol: 'CHF',
    symbolPlacement: 'before',
  },
];
